import { FormControl, Grid, MenuItem, Select } from '@material-ui/core';
import BarChart from 'components/common/chart/BarChart';
import CustomDatePicker from 'components/common/input/CustomDatePicker';
import MuiWrapper from 'components/common/input/MuiWrapper';
import AsyncFetchSelectWithAll from 'components/common/select/AsyncFetchSelectWithAll';
import CustomSpan from 'components/common/text/CustomSpan';
import CustomText from 'components/common/text/CustomText';
import useDateInput from 'lib/hooks/useDateInput';
import useInput from 'lib/hooks/useInput';
import { addCommas, projectStatusChartItemConverter } from 'lib/library';
import { ChartItem } from 'lib/types/dashboardTypes';
import { OffsetPagingData } from 'lib/types/sharedTypes';
import { debounce } from 'lodash';
import moment from 'moment';
import cx from 'classnames';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { DashboardActions, PartnerActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import { color } from 'styles/utils';
import { gridItemHorizentalMargin, gridItemVerticalMargin } from 'styles/_variables';
import { useDidUpdateEffect } from 'lib/utils';
import { useTranslation } from 'react-i18next';
import T from 'components/common/text/T';
import { isNormalLevelUserSelector } from 'store/modules/user';
import { icon_refresh } from 'components/base/images';
import MuiButton from 'components/common/button/MuiButton';
import { pageUrl, projectProcessFlagList } from 'lib/mapper';
import Tooltip from '@material-ui/core/Tooltip';
import styled, { createGlobalStyle } from 'styled-components';
import CustomTranslateTooltip from 'components/common/tooltip/CustomTranslateTooltip';

interface PatientToothTooltipProps {
  data?: any;
}

function PatientToothTooltip({ data }: PatientToothTooltipProps) {
  const { t } = useTranslation();

  const [isTitleHover, setIsTitleHover] = useState(false);
  const [isMemoHover, setIsMemoHover] = useState(false);
  const [isMemoModal, setIsMemoModal] = useState(false);
  useEffect(() => {
    if (!isTitleHover && !isMemoHover) {
      setIsMemoModal(false);
    } else {
      setIsMemoModal(true);
    }
  }, [isTitleHover, isMemoHover]);

  return (
    <StyledPatientToothTooltip data-component-name="PatientToothTooltip">
      <div className={cx('patientToothTooltip__wrapper ')}>
        <div className="patientToothTooltip__title ">
          <T>GLOBAL_TOOTH_NUMBER</T>
        </div>
        <div className="patientToothTooltip__contents ">
          {data?.map((item: any, idx: number) => {
            if (idx < data?.length - 1) {
              return `${item?.toothNumber}, `;
            } else {
              return `${item?.toothNumber}`;
            }
          })}
        </div>
      </div>
    </StyledPatientToothTooltip>
  );
}

const StyledPatientToothTooltip = styled.div<{}>`
  .patientToothTooltip__wrapper {
    background-color: #ffffff;
    width: 310px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 10px 10px 20px 0 rgba(0, 0, 0, 0.1);
    .patientToothTooltip__title {
      color: #303030;
      line-height: 26px;
      font-size: 18px;
      margin-bottom: 12px;
    }
    .patientToothTooltip__contents {
      /* height: 150px; */
      min-height: 90px;
      font-size: 14px;
      letter-spacing: -0.28px;
      line-height: 24px;
      color: #444444;
      overflow-y: overlay;
      text-overflow: ellipsis;
      word-break: break-all;
      white-space: break-spaces;
    }
  }
`;

export default React.memo(PatientToothTooltip);
